const all = ['patientManualPrescriptions']
const lists = [...all, 'list']
const list = (patientId: number) => [...lists, patientId]

export const patientManualPrescriptionsKeys = {
  all,
  lists,
  list,
}
